import React from "react";
import { Stack } from "@mui/material";
import SpecsJsonField from "./SpecsJsonField";
import SpecsNumberField from "./SpecsNumberField";
import { readObject } from "./utils";

export default function SpecsDeliveryTimeField({
  label,
  value,
  debugPath,
  clickToEdit,
  onChange,
}: {
  label: string;
  value: unknown;
  debugPath?: string;
  clickToEdit?: boolean;
  onChange: (nextValue: unknown) => void;
}) {
  const source = readObject(value);
  const { minWeeks, maxWeeks, ...extra } = source;

  return (
    <Stack spacing={1.5}>
      <SpecsNumberField
        label={`${label} Min Weeks`}
        value={typeof minWeeks === "number" ? minWeeks : null}
        allowNull
        debugPath={debugPath ? `${debugPath}.minWeeks` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextValue) =>
          onChange({
            ...extra,
            ...(nextValue === null ? {} : { minWeeks: nextValue }),
            ...(typeof maxWeeks === "number" ? { maxWeeks } : {}),
          })
        }
      />
      <SpecsNumberField
        label={`${label} Max Weeks`}
        value={typeof maxWeeks === "number" ? maxWeeks : null}
        allowNull
        debugPath={debugPath ? `${debugPath}.maxWeeks` : undefined}
        clickToEdit={clickToEdit}
        onChange={(nextValue) =>
          onChange({
            ...extra,
            ...(typeof minWeeks === "number" ? { minWeeks } : {}),
            ...(nextValue === null ? {} : { maxWeeks: nextValue }),
          })
        }
      />
      <SpecsJsonField
        label={`${label} Extra JSON`}
        value={extra}
        minRows={4}
        debugPath={debugPath}
        clickToEdit={clickToEdit}
        onChange={(nextExtra) =>
          onChange({
            ...readObject(nextExtra),
            ...(typeof minWeeks === "number" ? { minWeeks } : {}),
            ...(typeof maxWeeks === "number" ? { maxWeeks } : {}),
          })
        }
      />
    </Stack>
  );
}
